import chroma from "chroma-js";
import { sha1 } from "hash.js";

const colorScaleDark = chroma
  .cubehelix()
  .rotations(1)
  .hue(2)
  .lightness(0.3)
  .scale();

const colorCacheDark: Record<string, string> = {};

export function pickColorDark(hash: string) {
  if (!colorCacheDark[hash]) {
    const digits = sha1().update(hash).digest("hex");
    const alpha = parseInt(`${digits.slice(-6)}`, 16) / parseInt("ffffff", 16);
    colorCacheDark[hash] = colorScaleDark(alpha).css();
  }
  return colorCacheDark[hash];
}

const colorScaleExtraLight = chroma
  .cubehelix()
  .rotations(1)
  .hue(1)
  .lightness(0.9)
  .scale();

const colorCacheExtraLight: Record<string, string> = {};

export function pickColorExtraLight(hash: string) {
  if (!colorCacheExtraLight[hash]) {
    const digits = sha1().update(hash).digest("hex");
    const alpha = parseInt(`${digits.slice(-6)}`, 16) / parseInt("ffffff", 16);
    colorCacheExtraLight[hash] = colorScaleExtraLight(alpha).css();
  }
  return colorCacheExtraLight[hash];
}

export const spaceColorScheme = (numColors: number) => {
  // Colors derived from this figma: https://www.figma.com/file/mdtRUuSmqkmRMUW3P8ZDKr/Northbeam-Style-Guide?node-id=2284%3A7037&t=flbk0UugHRhGj4Sh-0
  const basicColors: string[] = [
    "#7081FF",
    "#BCFBBA",
    "#C825A8",
    "#71D5D5",
    "#F05F33",
    "#FFD247",
    "#50BA58",
    "#F3971A",
    "#004F2D",
    "#681E06",
  ];
  const repeatCount = Math.ceil(numColors / basicColors.length);

  return Array(repeatCount).fill(basicColors).flat();
};

export function colorGradient(numColors: number, startColor: string) {
  const rv = chroma.scale(["white", startColor]).colors(numColors + 2);
  rv.shift();
  rv.shift();
  return rv;
}
